module.exports = __webpack_public_path__ + "fonts/Gotham-Book.a8437603.ttf";